import keycloak from '../plugins/keycloak'

export default {
  baseUrl: '/api',
  baseHeader: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-requested-with': 'XMLHttpRequest',
  },

  /**
   * Request-wrap for global settings, interceptions,..
   *
   * @param {string} url
   * @param {object} options
   * @param {string} options.method
   * @param {any} options.body
   * @param {object} options.headers Additional headers (can override the default)
   * @returns {Promise}
   */
  async baseFetch (url = '', { method = 'GET', body, headers = {} } = {}) {
    try {
      await keycloak.instance.updateToken()
    } catch (error) {
      console.error('Failed to refresh token:', error)
      return keycloak.login()
    }

    const mergedHeaders = {
      ...this.baseHeader,
      ...headers,
      authorization: `Bearer ${keycloak.instance.token}`
    }

    // "fetch" will handle that for formdata-bodies
    if (body instanceof FormData) {
      delete mergedHeaders['Content-Type']
    }

    return await fetch(`${this.baseUrl}/${url}`, {
      headers: mergedHeaders,
      method,
      body,
    })
  },
}
